export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-target-853eb1d0f5286fb575f8bc866f2e8d33.svg";